import { createContext, useContext, useState, ReactNode } from "react";

interface TourContextType {
  startTour: () => void;
  stopTour: () => void;
  isTourRunning: boolean;
  currentStep: number;
}

const TourContext = createContext<TourContextType | undefined>(undefined);

export function TourProvider({ children }: { children: ReactNode }) {
  const [isTourRunning, setIsTourRunning] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  const startTour = () => {
    setIsTourRunning(true);
    setCurrentStep(0);
    sessionStorage.setItem('tourStarted', 'true');
    sessionStorage.setItem('tourStep', '0');
  };

  const stopTour = () => {
    setIsTourRunning(false);
    setCurrentStep(0);
  };

  return (
    <TourContext.Provider value={{ 
      startTour,
      stopTour,
      isTourRunning,
      currentStep
    }}>
      {children}
    </TourContext.Provider>
  );
}

export function useTour() {
  const context = useContext(TourContext);
  if (context === undefined) {
    throw new Error("useTour must be used within a TourProvider");
  }
  return context;
}
